var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1173 11.6721C8.15928 9.84251 6.21715 8.02774 4.26748 6.21707C4.14833 6.10597 4.11933 6.0455 4.24908 5.91034C4.82007 5.31794 5.38284 4.71046 5.93794 4.10324C6.08594 3.94055 6.19299 3.92529 6.35992 4.08466C8.21084 5.8181 10.0655 7.54757 11.92 9.27319C12.0748 9.41763 12.1207 9.51976 11.9539 9.69464C11.335 10.3463 10.7318 11.0052 10.1136 11.6761L10.1173 11.6721Z",
    fill: "#C7D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.16415 11.9374C3.18179 11.9717 2.20326 12.0059 1.2209 12.0402C1.15484 10.1484 1.09248 8.25262 1.03025 6.36067C1.50313 6.25963 1.98071 6.2929 2.45654 6.27628C2.9554 6.25886 3.45635 6.19143 3.95815 6.25843C4.02435 8.15408 4.09425 10.0458 4.16429 11.9413L4.16415 11.9374Z",
    fill: "#C7D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.26305 3.72667C6.22955 2.76733 6.19618 1.81183 6.15885 0.852622C8.05066 0.786558 9.94248 0.720495 11.8381 0.654297C11.8716 1.61364 11.905 2.56914 11.9347 3.52861C10.0467 3.59454 8.15487 3.66061 6.26689 3.72654L6.26305 3.72667Z",
    fill: "#C7D0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.87259 3.81071C2.89406 3.84488 1.91937 3.87891 0.940844 3.91309C0.907343 2.95375 0.873842 1.9944 0.840475 1.0389C1.819 1.00473 2.79753 0.97056 3.77222 0.936523C3.80572 1.89586 3.83922 2.8552 3.87272 3.81454L3.87259 3.81071Z",
    fill: "#C7D0CF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSvg);
export default __webpack_public_path__ + "static/media/hero-svg.42d46c03d8281d2c24426e3d2981358e.svg";
export { ForwardRef as ReactComponent };